import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Divider } from '@mui/material';
import VehiclesGrid from '../modules/VehiclesGrid';
import Page from '../components/Page/Page';
import Breadcrumbs from '../components/BreadCrumbs/BreadCrumbs';
import { PATHS } from '../utils/constants';
import { FolderTabs } from '../components';
import InventoryGrid from '../modules/InventoryGrid';

const InventoryNew = () => {
  // constants
  const links = [
    {
      label: 'Dashboard',
      link: PATHS.dashboard,
    },
    {
      label: 'Inventory',
      link: PATHS.inventory,
    },
  ];

  const navigate = useNavigate();

  return (
    <Page sx={{ p: 0.5 }}>
      <Breadcrumbs links={links} />
      <Divider sx={{ mt: 0.5 }} />

      <FolderTabs
        active={1}
        tabItems={[
          {
            label: 'Vehicles',
            onClick() {
              navigate('/v360-app/vehicles');
            },
            content: undefined,
          },
          {
            label: 'Inventory',
            // onClick() {
            //   navigate('/v360-app/inventory');
            // },
            content: <InventoryGrid />,
          },
        ]}
      />
    </Page>
  );
};

export default InventoryNew;
